import { render } from "./InsightsFeed.vue?vue&type=template&id=49118b1f&scoped=true"
import script from "./InsightsFeed.vue?vue&type=script&lang=js"
export * from "./InsightsFeed.vue?vue&type=script&lang=js"

import "./InsightsFeed.vue?vue&type=style&index=0&id=49118b1f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49118b1f"]])

export default __exports__